<div
  data-cy="warning-details"
  class="details position-absolute start-5 z-3 top-26 max-vh-70 overflow-auto"
  cdkDrag
  cdkDragBoundary="app-root"
  [class.d-none]="!hasDetails()"
>
  <app-details
    class="container-fluid p-0"
    (closed)="close()"
    (selectedItemChanged)="toggleFeature($event)"
    [numberOfDetails]="features.length"
    [index]="index"
  >
    <div class="p-2">
      <div class="row">
        <app-details-meta-category class="col gx-5" [category]="details().get('RawMetric')">
        </app-details-meta-category>

        <details-accordion-basic
          class="col-12 p-1 mt-2"
          [rawFeature]="rawFeature"
        ></details-accordion-basic>
        <div class="col-12 p-1">
          <button
            class="btn btn-dangerous text-lightgray miw-100 mt-2 position-relative"
            (click)="deleteWarning()"
            data-cy="warning-details-delete-button"
            [disabled]="isLoading"
          >
            <span [class.invisible]="isLoading">Delete warning</span>
            <div class="position-absolute translate-middle start-50 top-50">
              <div
                class="spinner-border text-lightgray spinner-border-sm"
                [class.d-none]="!isLoading"
                role="status"
              ></div>
            </div>
          </button>
        </div>
        <div class="col-12 text-white text-start mt-2">Report:</div>

        <div class="col-12 p-1">
          <a
            class="btn btn-card text-lightgray rb-ic rb-ic-mail-out text-gray fs-2xl miw-100 z-3 position-relative cursor-pointer hover-effect"
            [href]="mailToLink"
            target="_blank"
          >
          </a>
        </div>
      </div>
    </div>
    <div
      cdkDragHandle
      class="rb-ic rb-ic-drag-handle text-gray fs-2xl z-3 position-absolute bottom-2 end-2 cursor-pointer hover-effect"
    ></div>
  </app-details>
</div>
